<script>
  import PageHeader from '/components/Atoms/PageHeader'
  import Card from '/components/Atoms/Card'
  import MarkdownBlock from '/Atoms/MarkdownBlock'
  import SideGroup from '/components/Groups/SideGroup'
  import Related from '/Groups/Related'

  export let data, title

  let page = data?.Text || data?.Project || {}
  let blocks = data?.Text?.body || data?.Project?.body || []

  const sideWidgets = page?.relatedWidgets || []


  let body = blocks
  .map( e => {
    if (e.textBlock) return e.textBlock
    else if (e.imageBlock) {

      if (page.slug === "supporters") {
        let out = `<div class="single-page-logos">`
        out += e.imageBlock.map( 
          i => `
          <a class="single-page-logos-logo" title="${i.title}" href="${i.linkUrl}">
            <img alt="${i.title}" src="${i.url}" srcset="${i.url} 1x, ${i.url2x} 2x" />
          </a>`
        ).join(" ")
        out += `</div>`
        return out + "\n"
      }

      if (page.slug === "press-images") {
        let out = `<div class="single-page-press-images">`
        out += e.imageBlock.map( 
          i => `
          <figure class="single-page-press-images-item">
            <a  title="${i.title}" href="${i.original}" download target="_blank">
              <img alt="${i.title}" src="${i.url}" srcset="${i.url} 1x, ${i.url2x} 2x" />
            </a>
            <figcaption>
              ${i.imageCaption || i.title}
            </figcaption>
          </figure>`
        ).join(" ")
        out += `</div>`
        return out + "\n"
      }
    }
  })
  .join("\n")



</script>

<div class="container">

  {#if title}
    <div class="header">
      <PageHeader>
        {title}
      </PageHeader>
    </div>
  {/if}

  <section class="main">
    <Card>
      {#if body}
        <MarkdownBlock source={body} />
      {/if}
    </Card>

    <Related data={page} />

  </section>

  <aside class="side">
    <SideGroup widgets={sideWidgets} />
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }
  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
    

  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  :global(.single-page-logos) {
    padding: 2em 0;

    @include media-large-only {
      width: 100%;
      display: grid;
      flex-direction: row;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 6%;
      grid-auto-rows: 120px;

      :global(a), :global(img) {
          width: 100%;
          height: 100%;
        }
      :global(img) {
        object-fit: contain;
      }
    }

    @include media-small {
      :global( > * ) {
        max-width: 250px;
        display: block;
        margin-bottom: 1em;
      }
    }

  }    

  :global(.single-page-press-images) {
    padding: 2em 0;

    width: 100%;
    display: grid;
    flex-direction: row;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 1em;

    :global(.single-page-press-images-item) {
      margin-bottom: 1em;
      @include typo-grotesk-title-captions-20;
    }

  }    


</style>
